<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Prospects de Hoje e Pendentes</h6>
        <i class="bi bi-x-circle close-icon" @click="$emit('fechar')" title="Fechar"></i>
      </div>

      <!-- Tabela de Prospects -->
      <div class="table-container">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th>Prospecção</th>
              <th>Aluno</th>
              <!-- <th>Responsável</th> -->
              <!-- <th>Telefone</th> -->
              <th>Última ação</th>
              <th>Agendamento</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!sortedProspects.length">
              <td colspan="7" class="text-center">Nenhum prospect para hoje ou pendente.</td>
            </tr>
            <tr v-else v-for="item in sortedProspects" :key="item.id">
              <!-- Aplica cor conforme data_proximo_contato -->
              <td>{{ item.id }}</td>
              <td>{{ item.nome_aluno }}</td>
              <!-- <td :class="classeProspect(item.data_proximo_contato)">{{ item.nome }}</td> -->
              <!-- <td :class="classeProspect(item.data_proximo_contato)">{{ item.telefone }}</td> -->
              <td>{{ item.acao }}</td>
              <td :class="classeProspect(item.data_proximo_contato)">{{ formatarData(item.data_proximo_contato) }}</td>
              <td class="text-center">
                <i
                  class="bi bi-arrow-right-circle action-icon"
                  title="Detalhar Prospeccao"
                  @click="detalhar(item.id)"
                ></i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProspectsHoje',
  props: {
    mostrar: { type: Boolean, default: false },
    prospects: { type: Array, default: () => [] }
  },
  emits: ['fechar'],
  computed: {
    sortedProspects() {
      return this.prospects
        .slice()
        .sort((a, b) => {
          const da = new Date(a.data_proximo_contato.split('T')[0] + 'T00:00:00');
          const db = new Date(b.data_proximo_contato.split('T')[0] + 'T00:00:00');
          return db - da; // decrescente
        });
    }
  },
  methods: {
    formatarData(dataProximo) {
      if (!dataProximo) return '-';
      const [ymd] = dataProximo.split('T');
      const [year, month, day] = ymd.split('-');
      return `${day}/${month}/${year}`;
    },
    classeProspect(dataProximo) {
      if (!dataProximo) return '';
      const hoje = new Date();
      const [ymd] = dataProximo.split('T');
      const data = new Date(`${ymd}T00:00:00`);
      if (data.toDateString() === hoje.toDateString()) {
        return 'text-normal';
      }
      if (data < hoje) {
        return 'text-danger';
      }
      return '';
    },
    detalhar(id) {
      this.$emit('fechar');
      this.$router.push({ name: 'DetalharProspeccao', params: { id } });
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  overflow-y: auto;
  border-radius: 4px;
  z-index: 2001;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #f1f1f1;
  border-bottom: 1px solid #ddd;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}

.table-container {
  padding: 15px;
}

.table th,
.table td {
  vertical-align: middle;
}

.action-icon {
  cursor: pointer;
  font-size: 1.2rem;
  color: #007bff;
}

.action-icon:hover {
  color: #0056b3;
}

.text-primary { color: #0d6efd; }
.text-danger  { color: #dc3545; }
</style>
